import { useMemo } from 'react'
import { GuidedToursCatalog } from '@userhub/widget'
import { tourShareUrl } from '../lib/router'
import { toCatalogEntry } from '../tours/catalog'
import type { TourDef } from '../tours/types'
import { trainingClient } from './training'

interface ToursCatalogProps {
  open: boolean
  onClose: () => void
  /** The tours available to the user (already filtered on `requires`). */
  tours: readonly TourDef[]
  onStartTour: (def: TourDef) => void
  /** A tour link's number: that row is selected, its Start focused. Unknown → the "not available" message. */
  selectedNumber?: number | null
}

/**
 * The userhub catalog of every guided tour (the widget's Fluent dialog, themed by UserhubShell),
 * on the app's one training client so it shares the tours window's records. Its Start starts the
 * tour at once (userhub plan G8); Copy link uses the public web origin (lib/router.ts#tourShareUrl).
 */
export function ToursCatalog({ open, onClose, tours, onStartTour, selectedNumber }: ToursCatalogProps) {
  const entries = useMemo(() => tours.map(toCatalogEntry), [tours])
  return (
    <GuidedToursCatalog
      open={open}
      onClose={onClose}
      tours={entries}
      onStartTour={(n) => {
        const def = tours.find((d) => d.number === n)
        if (def) onStartTour(def)
      }}
      selectedNumber={selectedNumber ?? null}
      tourLink={tourShareUrl}
      apiClient={trainingClient()}
    />
  )
}
